module.exports = __webpack_public_path__ + "img/selected.2964c0d7.svg";